import { QUOTA_FORM_HIERARCHY_KEYS } from './constants'

import type { FilterOption } from '@app/types/filter'

export const hierarchySelectOptions: FilterOption[] = [
  {
    value: QUOTA_FORM_HIERARCHY_KEYS.trendId,
    label: 'Направление'
  },
  {
    value: QUOTA_FORM_HIERARCHY_KEYS.purchasingGroupId,
    label: 'Группа закупок'
  },
  {
    value: QUOTA_FORM_HIERARCHY_KEYS.commodityGroupId,
    label: 'Товарная группа'
  },
  {
    value: QUOTA_FORM_HIERARCHY_KEYS.categoryId,
    label: 'Категория'
  },
  {
    value: QUOTA_FORM_HIERARCHY_KEYS.subcategoryId,
    label: 'Подкатегория'
  }
]
